var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8EditRow50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M43,30V18c0-2.206-1.794-4-4-4H9c-2.206,0-4,1.794-4,4v12c0,2.206,1.794,4,4,4h30C41.206,34,43,32.206,43,30z M9,18h30v12L9,30.002V18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e57373",
    d: "M43.678,3.142l-2.82-2.82c-0.43-0.43-1.126-0.43-1.555,0l-1.327,1.327l4.375,4.376l1.327-1.327C44.107,4.268,44.107,3.571,43.678,3.142z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M23.11 9.088H40.525999999999996V15.276H23.11z",
    transform: "rotate(-45.001 31.818 12.183)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M37.522 1.837H40.616V8.025H37.522z",
    transform: "scale(-1) rotate(-44.996 -11.905 94.324)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M23.472 16.152L22 22 27.848 20.528z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M22.744 19.044L22 22 24.956 21.256z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8EditRow50);
export default __webpack_public_path__ + "static/media/icons8-edit-row-50.e23564c9111ab435b63e843e75f6944f.svg";
export { ForwardRef as ReactComponent };